import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LabelValuePair } from '@ddv/models';

@Component({
    selector: 'ddv-bar-color',
    templateUrl: './bar-color.component.html',
    styleUrls: ['./bar-color.component.scss'],
})
export class BarColorComponent implements OnInit {
    @Input() value: string | undefined;
    @Input() barColors: LabelValuePair<string>[] = [];
    @Output() colorSelected = new EventEmitter<string>();

    protected allColorsMap: Map<string, { [key: string]: string }> | undefined;

    ngOnInit(): void {
        this.allColorsMap = this.createColorsMap();
    }

    protected onColorSelected(item: LabelValuePair<string>, el: HTMLDivElement): void {
        el.hidden = true;
        this.colorSelected.emit(item.value);
    }

    private createColorsMap(): Map<string, { [key: string]: string }> {
        const colorsReducer = (colors: LabelValuePair<string>[]): Record<string, string> => colors.reduce((accum, color) => {
            accum[color.value] = color.label;
            return accum;
        }, {} as Record<string, string>);
        const colorsMap = new Map<string, { [key: string]: string }>();
        colorsMap.set('barColor', colorsReducer(this.barColors));
        return colorsMap;
    }
}
